<template>
      <div class="card-container d-flex gap-2 justify-content-center m-4">
          <div class="card-item bg-dark text-light p-4 rounded w-30">
            <div class="d-flex gap-2 align-items-baseline mb-2">
              <i class="fa fa-map-marker" aria-hidden="true"></i>
              <h4>نشانی ما</h4>
            </div>
            <p>
              استان خراسان رضوی، شهرستان تربت جام،محله: شهرک آزادگان، معبر ماقبل آخر: کوچه شهید عباسپور 13 (انصار 10)، معبر آخر: خیابان آزادگان  شهید عباسپور 15، پلاک 0،ساختمان دفتر سفارش آنلاین راداَپ وحید سعیدی راد، طبقه همکف 
              <br />
              کد پستی : 9571744435
            </p>
          </div>
          <div class="card-item bg-dark text-light p-4 rounded w-30">
            <div class="d-flex gap-2 align-items-baseline mb-2"> 
              <i class="fa fa-phone" aria-hidden="true"></i>
              <h4>تماس با ما</h4>
            </div>
            <div class="d-flex flex-column text-left" style="direction: ltr;" >
							<a href="tel:05152524850" target="_blank">051-52524850</a>
              <a href="tel:09928728971" target="_blank">0992-872-8971</a>
							<a href="tel:09903573351" target="_blank">0990-357-3351</a>
            </div>
          </div>
          <div class="card-item bg-dark text-light p-4 rounded w-30">
            <div class="d-flex gap-2 align-items-baseline mb-2">
              <i class="fa fa-message" aria-hidden="true"></i>
              <h4>ایمیل</h4>
            </div>
            <a href="mailto:info.radap@gmail.com">info.radap@gmail.com</a>
          </div>
        </div>
</template>

<style scoped>
@media (max-width :800px){
  .card-container{
    flex-direction: column;
  }
  .card-item{
    width: 100% !important; 
  }
}
a{
  color: white;
}
.w-30{
  width: 30%;
}
i{
  vertical-align: middle;
}
h4{
  margin-bottom: 0;
}
</style>